

export default function copyTextToClipboard (text, MessageHelper, successMessage, failureMessage) {
    if (!navigator.clipboard) {
      fallback(text, MessageHelper, successMessage, failureMessage)
      return
    }

    navigator.clipboard
        .writeText(text)
        .then(() => MessageHelper.message(successMessage))
        .catch((err) => {
            MessageHelper.error(failureMessage)
            console.log(err)
        })
}

function fallback (text, MessageHelper, successMessage, failureMessage) {
    const textArea = document.createElement('textarea')
    textArea.value = text
    textArea.style.top = '0'
    textArea.style.left = '0'
    textArea.style.position = 'fixed'

    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()

    try {
      const success = document.execCommand('copy')
      if (success) MessageHelper.message(successMessage)
      else MessageHelper.error(failureMessage)

    } catch (err) {
        MessageHelper.error(failureMessage)
        console.log(err)
    }

    document.body.removeChild(textArea)
}